import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=1a5161e6&"
import script from "./JobDetail.vue?vue&type=script&lang=js&"
export * from "./JobDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a5161e6', component.options)
    } else {
      api.reload('1a5161e6', component.options)
    }
    module.hot.accept("./JobDetail.vue?vue&type=template&id=1a5161e6&", function () {
      api.rerender('1a5161e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Index/JobDetail.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Index/JobDetail.vue
// module id = 9dtO
// module chunks = 0